(function() {
  var COLLECTION_KEY_PREFIX = 'collection-scroll-pos-';
  var LEGACY_KEY_PREFIX = 'scroll-pos-';

  function getCollectionKey() {
    return COLLECTION_KEY_PREFIX + location.pathname + location.search;
  }

  function isCollectionPage() {
    return !!document.querySelector('#product-grid');
  }

  var LAST_COLL_KEY = 'csd-last-collection-key';

  function saveScrollPosition() {
    var key = getCollectionKey();
    var pos = window.scrollY;
    sessionStorage.setItem(key, pos);
    sessionStorage.setItem(LAST_COLL_KEY, key);
  }

  function restoreScrollPosition() {
    if (!isCollectionPage()) return;

    var key = getCollectionKey();
    var saved = sessionStorage.getItem(key);
    if (saved === null) return;

    restoreScrollTo(parseInt(saved, 10), key);
  }

  function restoreScrollTo(targetY, key) {
    var maxAttempts = 30;
    var attempt = 0;

    function tryScroll() {
      attempt++;
      var grid = document.querySelector('#product-grid');
      if (grid && grid.children.length > 0) {
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo(0, targetY);
        document.documentElement.style.scrollBehavior = '';
        sessionStorage.removeItem(key);
        sessionStorage.removeItem(LAST_COLL_KEY);
        var legacyKey = LEGACY_KEY_PREFIX + key.slice(COLLECTION_KEY_PREFIX.length);
        sessionStorage.removeItem(legacyKey);
      } else if (attempt < maxAttempts) {
        requestAnimationFrame(tryScroll);
      }
    }

    requestAnimationFrame(tryScroll);
  }

  function isProductPage() {
    return location.pathname.includes('/products/');
  }

  function clearLastCollectionKey() {
    var lastKey = sessionStorage.getItem(LAST_COLL_KEY);
    if (lastKey) {
      sessionStorage.removeItem(lastKey);
      sessionStorage.removeItem(LAST_COLL_KEY);
      var legacyKey = LEGACY_KEY_PREFIX + lastKey.slice(COLLECTION_KEY_PREFIX.length);
      sessionStorage.removeItem(legacyKey);
    }
  }

  function initCollectionFeature() {
    if (isCollectionPage()) {
      history.scrollRestoration = 'manual';

      var lastClickedUrl = '';

      document.addEventListener('click', function(e) {
        var link = e.target.closest('a');
        if (!link) return;

        lastClickedUrl = link.href || '';

        var isProductLink = lastClickedUrl.includes('/products/');
        var isWithinGrid = document.querySelector('#product-grid') && document.querySelector('#product-grid').contains(link);

        if (isProductLink && isWithinGrid) {
          saveScrollPosition();
        } else if (lastClickedUrl && lastClickedUrl !== location.href) {
          clearLastCollectionKey();
        }
      });

      window.addEventListener('pagehide', function() {
        if (lastClickedUrl.includes('/products/')) {
          saveScrollPosition();
        } else {
          clearLastCollectionKey();
        }
      });

      window.addEventListener('pageshow', function(e) {
        if (e.persisted) {
          restoreScrollPosition();
        }
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', restoreScrollPosition);
      } else {
        restoreScrollPosition();
      }
    } else if (!isProductPage()) {
      clearLastCollectionKey();
    }
  }

  initCollectionFeature();
})();
